export class ComponentConstants {
  public static readonly CREATE_FOLDER = "Create Folder";
  public static readonly GENERAL_INFORMATION = "General Information";
  public static readonly TRANSFER_PACKAGE = "Transfer Package";
  public static readonly FOLDER_PERMISSION = "Folder Permission";
  public static readonly SHARE = "Share";
  public static readonly MOVE = "Move";
  public static readonly STUDYDATACOLLECTION = "Study Data Collection";
  public static readonly FACILITYDATACOLLECTION = "Facility Data Collection";
  public static readonly PREARCHIVE = "Pre-Archive";
  public static readonly FACILITYARCHIVE = "Facility Archive";
  public static readonly BU_GLOBAL = "Global";
  public static readonly DELETE_FOLDER = "Delete";
  public static readonly FILE_VERSION_HISTORY = "Version History";
  public static readonly UPDATETAG = "UpdateTag";
  public static readonly MULTIPLETAGS = "Multiple Tags";
  public static readonly PACKAGE_FOLDER_TAGS = "Package Folder Tags";
  public static readonly TEMPLATES = "Folder Templates";
}

export class BucketTypeConstants {
  public static readonly STUDYDATACOLLECTION = "StudyDataCollection";
  public static readonly FACILITYDATACOLLECTION = "FacilityDataCollection";
  public static readonly PREARCHIVE = "PreArchive";
  public static readonly FACILITY_ARCHIVE = "FacilityArchive";
}

export class FolderTypeConstants {
  public static readonly STUDY_PACKAGE = "StudyPackage";
  public static readonly FACILITY_PACKAGE = "FacilityPackage";
}

export class ErrorConstants {
  public static readonly NOT_AUTHORIZED = "You are not authorized";
  public static readonly FILE_SIZE_GREATER_2GB = "Max. allowed upload size is 2 GB";
  public static readonly FILE_NUMBER_LIMIT = "Max. allowed files to upload is 100,000";
  public static readonly CHECKSUM_FAIL =
    "Upload Failed : Checksum generation for file failed, please try again";
  public static readonly FILE_FOLDER_MISSING_UPLOAD =
    "Please select a file/folder to upload";
  public static readonly ONLY_ONE_FOLDER_ALLOWED_AT_PACKAGE_LEVEL =
    "Only one folder may be uploaded at this level. Please select a single folder and try again";
  public static readonly EMPTY_FOLDERS_DETECTED_UPLOAD_FOLDER =
    "One or more empty folders were detected. Empty folders cannot be uploaded using Upload Folder. Use Drag and Drop to upload empty folders";
  public static readonly UPLOAD_FAIL = "Upload Failed";
  public static readonly SELECT_OR_CREATE_FOLDER =
    "Please create and/or navigate to a folder first";
  public static readonly DO_NOT_HAVE_STUDY_ACCESS =
    "You do not have study access in eSM to transfer Study Package(s)";
  public static readonly YOU_DO_NOT_HAVE_ACCESS_TO_PREARCHIVE_BUCKET_TO_TRANSFER =
    "You do not have access to the Pre - Archive Bucket of the Study BU";
  public static readonly PLEASE_SELECT_STUDY_PACKAGE_FOLDERS_FROM_SAME_BU =
    "Please select Study Package Folders from the same BU";
  public static readonly STUDY_NOT_MAPPED_TO_BU = "Study not mapped to BU";
  public static readonly DOWNLOAD_FAILED =
    "Download failed! Please try again after some time";
  public static readonly DOWNLOAD_SIZE_REACHED =
    'Maximum permitted limit to download in single attempt is "1 GB"';
  public static readonly MAX_DOWNLOAD_LIMIT = "Max Download Limit reached!";
  public static readonly MAX_DOWNLOAD_FOR_LARGE_FILE ="Maximum permitted limit to download in single attempt is \"10 gb\".";
  public static readonly EXPORT_AUIDT_TRAIL_FAILED = "Export of audit trail failed";
  public static readonly EXPORT_CONTENT_FAILED = "Export content failed";
  public static readonly ONLY_EMPTY_FOLDERS_CAN_BE_DELETED =
    "Only empty folders can be deleted.";
  public static readonly SELECT_FOLDER_FOR_FILE_VERSION =
    "Version history is only applicable to file and not folder";
  public static readonly UPDATE_TAG_VALUE = "Update a Tag value first.";
  public static readonly PACKAGE_ACCESS_CREATION_FAILED = "Package folder access request creation failed";
  public static readonly PACKAGE_LOCKED = "Package is locked, please try again later";
  public static readonly REVOKE_PACKAGE_ACCESS_FAILED = "Revoke package folder access failed";
  public static readonly REJECT_PACKAGE_ACCESS_FAILED = "Reject package folder access failed";
  public static readonly APPROVE_PACKAGE_ACCESS_FAILED = "Approve package folder access failed";
  public static readonly SELECT_FILE_FOR_VERSION_HISTORY =
  "Please select/upload a file to view the version history ";
  public static readonly MALICIOUS_WARNING = "Some files are quarantined and were not included in the operation. Please contact eArchive_support@it.eurofinseu.com for more information";
  public static readonly MAXIMUM_RECORDS_AUDITLOGS = "The number of records returned exceeds the size limit of 10000 results. Change the search criteria to return fewer records";
  public static readonly TEMPLATE_DOWNLOAD_FAILED = "Template cannot be downloaded at the moment. Please try again later.";
  public static readonly UPDATE_TAGS_FAILED = "Updating of tags failed. Please contact support";
  public static readonly INVALID_STUDY_CODE_MESSAGE = "Please enter valid Study code";
  public static readonly INVALID_FOLDER_NAME_MESSAGE = "Please enter valid folder name";
  public static readonly FILES_CANNOT_MOVE_TO_BUCKET_LEVEL = "Files cannot be moved to the bucket level";
}

export class CommonConsants {
  public static readonly FOLDER_NAME_EXSISTS_ERROR = "Folder name already exists";
  public static readonly SUCCESS_FILE_UPLOAD = "Files uploaded successfully";
  public static readonly FOLDER_CREATION_FAILED = "Folder creation failed";
  public static readonly FOLDER_CREATION_SUCCESS = "Folder created successfully";
  public static readonly COPY_CLIPBOARD_SUCCESS = "Checksum Copied to ClipBoard";
  public static readonly CHECKSUM_MATCH =
    "Checksums match, file integrity could be verified";
  public static readonly REGENERATE_CHECKSUM_FAILED = "Re-generate Checksum failed";
  public static readonly CHECKSUM_FAIL_TOOLTIP =
    "There is an issue with the file integrity.Please, contact support.";
  public static readonly FOLDER_OR_FILE_DOES_NOT_EXIST = "Folder/File does not exist in the storage";
  public static readonly CHECKSUM_MISMATCH =
    "Checksums don't match, please verify file integrity";
  public static readonly PACKAGE_ACCESS_CREATED = "Package folder access request has been created successfully";  
  public static readonly PACKAGE_ACCESS_REVOKED = "Package folder access revoked successfully";  
  public static readonly PACKAGE_ACCESS_APPROVED = "Package folder access approved successfully";
  public static readonly PACKAGE_ACCESS_REJECTED = "Package folder access rejected successfully";
  public static readonly EMAIL_ID_COPIED = "Email id is copied to clipboard";
  public static readonly JUSTIFICATION_SUCCESS = "Justification saved successfully";
  public static readonly JUSTIFICATION_FAILURE = "Justification cannot be saved at the moment. Please try again later.";
  public static readonly DOWNLOAD_MALICIOUS_FILES_SUCCESS = "Your request for malicious file download is successfully registered. Please wait for the email";
  public static readonly DOWNLOAD_MALICIOUS_FILES_FAILURE = "Your request for malicious file download is failed. Please contact support";
  public static readonly DOWNLOAD_MALICIOUS_FILES_MAX_ERROR = "Please select less than 10 files for downloading";
  public static readonly UPDATE_TAGS_PARTIAL_PERMISSION = "Tag(s) with insufficient permissions are not applied";
  public static readonly LOAD_PACKAGE_FOLDER_TEMPLATE_SUCCESS = "Package folder template loaded successfully";
  public static readonly LOAD_SUB_FOLDER_TEMPLATE_SUCCESS = "Subfolder template loaded successfully";
  public static readonly FILES_AND_FOLDERS_MAX_LENGTH = 150;
  public static readonly UPDATE_TAG_ACTION = "update tag";
  public static readonly BUCKET_ITEM_ID_COLUMN_NAME = "BucketItemId";
  public static readonly PACKAGE_LOCK_ERROR = "Package folder is currently in use. Please try later.";
}

export class ActionConstants {
  public static readonly RENAME = "Rename";
  public static readonly FOLDER_PERMISSION = "AllowGuestAccess";
  public static readonly DOWNLOAD = "Download";
  public static readonly TRANSFER = "Transfer";
  public static readonly MOVE = "Move";
  public static readonly DELETE = "Delete";
  public static readonly EXPORT_AUDIT_TRAIL = "Export Audit Trail";
  public static readonly RENAME_FOLDER_PERMISSION = "RenameFolder";
  public static readonly DELETE_FOLDER_PERMISSION = "DeleteFolder";
  public static readonly EXPORTAUDITTRAIL = "ExportAuditTrail";
  public static readonly EXPORT_CONTENT = "Export Content List";
  public static readonly TAGS = "Tags";
}

export class PermissionConstants{
  public static readonly ALLOW_GUEST_ACCESS = "arc.allowguestaccess";
  public static readonly IS_GLP_MANAGER = "isglpmanager";
  public static readonly DISPLAY_AUDIT_TRAIL = "displayaudittrail";
  public static readonly SDC_AUTOMATED_TRANSFER = "sdc.automatedtransfers";
  public static readonly FDC_AUTOMATED_TRANSFER = "fdc.automatedtransfers";
  public static readonly SDC_JUSTIFICATION = "sdc.justification";
  public static readonly FDC_JUSTIFICATION = "fdc.justification";
  public static readonly PAC_JUSTIFICATION = "pac.justification";
  public static readonly DISPLAY_MALICIOUS_FILES = "displaymaliciousfiles";
  public static readonly IT_ADMIN = "itadmin";
  public static readonly IT_SUPPORT = "itsupport";
}

export class LoadTemplateModeConstants {
  public static readonly STUDY = 'STUDY_FOLDER';
  public static readonly PACKAGE = 'PACKAGE_FOLDER';
  public static readonly SUBFOLDER = 'SUB_FOLDER';
}

export class TemplateDialogTitleConstants {
  public static readonly STUDY = 'Enter valid study code';
  public static readonly PACKAGE = 'Enter package folder name';
  public static readonly SUBFOLDER = 'Enter sub folder name';
}

export class DialogConfig {
  public static readonly TAG_MISMATCH = {
    WIDTH: '650px',
    HEIGHT: {
      SMALL: '450px',
      MEDIUM: '600px',
      LARGE: '700px'
    },
    THRESHOLDS: {
      SMALL: 3,
      MEDIUM: 6
    }
  };
}

export class BucketItemTypeConstants {
  public static readonly FILE = "File"
  public static readonly FOLDER = "Folder"
}
